import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus-circle-alt",
  "use": "plus-circle-alt-usage",
  "viewBox": "0 0 34 34",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34 34\" id=\"plus-circle-alt\"><g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#6644EA\" stroke-linecap=\"round\" stroke-linejoin=\"round\" transform=\"translate(1 1)\"><circle cx=\"16\" cy=\"16\" r=\"16\" /><path d=\"M16 9.6v12.8M9.6 16h12.8\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol